import { useNavigate } from "react-router-dom";

/**
 * Navegação para uma rota de outro produto.
 *
 * Com host único (ver product-module.ts) isso é navegação normal de SPA — a
 * versão anterior trocava de origem com window.location.assign porque os
 * produtos viviam em hostnames diferentes.
 */
export const useProductNavigate = () => {
  const navigate = useNavigate();
  return (_module: "consortium" | "insurance", to: string) => navigate(to);
};
